import {debounce} from '../utils/utilities.js';
var $ = jQuery;

/* eslint-disable */
import featherlight from '../libs/featherlight.js';
/* eslint-enable */

export function init() {


  var $component = $('.navigation-global');
  var $fixWrapper = $('.navigation-global__fix-wrapper');
  var $progressBar = $('.article-progress');
  var $articleTitle  = $('.navigation__article-title');
  var position = $(window).scrollTop();

  var dir;
  var dimensions = getHeights();


  if($('.page-node-type-report').length > 0) {

    setNav();
    // TEMP
    let headline = $('.article-headline').text();
    $articleTitle.html(headline);
    // ENDTEMP

    $(window).on('scroll', setNav);
    $(window).on('scroll', getArticle);

    $(window).on('resize', debounce(function() {
      resetVals();
    }, 250));

    $articleTitle.on('click', backToTop);
  }

  function backToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
  }

  function resetVals() {
    dimensions = getHeights();
  }

  function setNav() {
    dir = getDirection();
    let opDir = dir === '_down' ? '_up' : '_down';

    if(position > 20) {
      if(!$component.hasClass('_inactive')) {
        $fixWrapper.addClass('_inactive');
      }
    }
    else {
      $fixWrapper.removeClass('_inactive');
    }

    if(!$component.hasClass(dir)) {
      $component.removeClass(opDir).addClass(dir);
    }
  }

  function getArticle() {
    let currentPosition = $(window).scrollTop();
    let positions = getPositions();

    dimensions = getHeights();

    for(var i = 0; i < positions.length; i ++) {
      let next = positions[i+1] === undefined ? Math.max($(document).height(), $(window).height()) : positions[i+1];
      if(((currentPosition >= positions[i]) && (currentPosition <= next)) || currentPosition < positions[0]) {
        // let headline = $('.article-headline')[i];
        // let headlineText = $(headline).find('span').text();

        // if(headlineText !== $articleTitle.text()) {
        //   // $articleTitle.html(headlineText);
        //   $progressBar.width(0+'%');
        // }

        $progressBar.width(0+'%');

        let $btn = $('.article-body__read-more')[i];

        if($($btn).hasClass('_inactive')) {
          let perc = getPercent(dimensions[i].offset, dimensions[i].height);
          let scrollPercent = perc > 100 ? 100 : perc;

          $progressBar.width(scrollPercent+'%');
          setProgress(scrollPercent);
        }

        break;
      }
    }

  }

  function getHeights() {
    let heights = [];
    let $sections = $('.article__body-copy ');
    for(let i = 0; i < $sections.length; i ++) {
      heights.push({
        'height': $($sections[i]).outerHeight(true),
        'offset': $($sections[i]).offset().top
      });
    }
    return heights;
  }

  function getPositions() {
    let positions = [];
    let $sections = $('.headline');

    for(let i = 0; i < $sections.length; i ++) {
      if(i === 0) {
        positions.push($($sections[i]).offset().top - $($sections[i]).outerHeight());
      }
      else {
        positions.push($($sections[i]).offset().top - $($sections[i]).outerHeight());
      }
    }
    return positions;
  }

  function setProgress(scrollPercent) {
    if(scrollPercent > 30 && dir === '_down') {
      if(!$fixWrapper.hasClass('_compact')) {
        $fixWrapper.addClass('_compact');
      }
    }
    else {
      $fixWrapper.removeClass('_compact');
    }
  }

  function getPercent(articleOffset, articleHeight) {
    return 100 * ($(window).scrollTop() - articleOffset) / (articleHeight -$(window).height());
  }

  function getDirection() {
    var scroll = $(window).scrollTop();
    let dir = '_down';

    if (scroll > position) {
      dir =  '_down';
    }
    else {
      dir =  '_up';
    }

    position = scroll;

    return dir;
  }
  var delay = (function() {
    var timer = 0;

    return function(callback, ms) {
      clearTimeout (timer);
      timer = setTimeout(callback, ms);
    };
  })();

  $(function() {
    var pause = 100;
    var $window = $(window);

    // [RK] Fires the function when resizing from higher breakpoints to Mobile, when doc isn not reloaded
    $window.resize(function() {

      delay(function() {

        // var docHeight = $(document).height();
        var docWidth = $(window).width();
        // var $bar = $('.navigation-global__progress-bar-indicator');
        // var barBase = $window.height() / docHeight * 100;

        // [RK] Checks if the breakpoint is Mobile
        if( docWidth <= 767 ) {

          // Progress bar Mobile function
          // $bar.css('width', barBase + '%');
          // $window.scroll(function(e) {
          //   var barFiller = $window.scrollTop() / docHeight * 100 + barBase;
          //   $bar.css('width', barFiller + '%');
          // });
        }

        /* [RK] Checks if the breakpoint is Tablet, Fires the function only after the breakpoint is hit
        and not when the doc loads on Mobile and then resizes to tab */
        else if( docWidth >= 767) {

          // Rotate top issues
          // rotateTerm();
        }

      }, pause );
    });

    $(window).resize();
  });

  // Mobile overlay Toggle
  function overlayToggle() {
    $component.find('.navigation-global__menu-mobile').on('click', function() {

      // [RK] Makes sure the breakpoints switch does not let the animation hide the dom elements
      $('.navigation-global__top-issues-text').css({'opacity': '1'});
      $('.navigation-global__issue-list1 > li').css({'opacity': '1'});
      $('.navigation-global__issue-list2 > li').css({'opacity': '1'});
      $('.navigation-global__issue-category').css({'opacity': '1'});
      $('.navigation-global__nav-bar-wrap').css({'display': 'none'});
      $('.navigation-global').find('.navigation-global__issue-expanded').slideToggle('slow');
    });

    $component.find('.navigation-global__close-icon').on('click', function() {
      $('.navigation-global__issue-expanded').css({'display': 'none'});
      $component.find('.navigation-global__nav-bar-wrap').show();
    });
  }
  overlayToggle();


  function toggleMenu() {
    var $btn = $('.navigation-global__issue-toggle-text');
    if($btn.hasClass('_main-open')) {
      $btn.removeClass('_main-open');
      $('.page__wrapper').off('click', toggleMenu);
    }
    else {
      $btn.addClass('_main-open');
      $('.page__wrapper').on('click', toggleMenu);
    }

    $('.navigation-global').find('.navigation-global__issue-expanded').slideToggle(300);
  }

  // Toggle open state for navigation
  function issueToggle() {

    $('.navigation-global__issue-expanded').on('click', function(e) {
      e.stopPropagation();
    });

    $component.find('.navigation-global__issue-toggle-text').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu();
    });
  }

  issueToggle();
}
